import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const AboutService = createApi({
	reducerPath: "AboutService",
	baseQuery: fetchBaseQuery({
		baseUrl:
			"https://allvehicles-backend.developer-ourbase-camp.com/api/pages/",
	}),
	endpoints: (builder) => {
		return {
			aboutApi: builder.query({
				query: () => {
					return {
						url: "about-us",
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useAboutApiQuery } = AboutService;
export default AboutService;
